export default __webpack_public_path__ + "static/media/logo_turbo.86e63670.webp";